import { FormLabel, Grid, MenuItem, Select } from "@material-ui/core";
import * as _ from "lodash";
import * as React from "react";
import { Range } from "react-input-range";
import { connect } from "react-redux";

import { Dispatch, StoreState } from "../../store";
import {
  AgeGroupLabel,
  AgeGroupType,
  ComplaintType,
  ComplaintTypeLabel,
  CustomerGroupFilterState,
} from "../../types/index";
import ActiveChurnedFilter from "../ActiveChurnedFilter";
import Autocomplete from "../Autocomplete";
import Slider from "../Slider";
import { FilterGroup } from "./constants";
import FilterContainer from "./FilterContainer";

function mapStateToProps({
  customerAddressPostalCodes,
  salutationsData: { salutationsData },
}: StoreState) {
  return {
    customerAddressPostalCodes,
    salutationsData,
  };
}

function mapDispatchToProps(dispatch: Dispatch) {
  return {
    fetchCustomerAddressPotalCodes: () =>
      dispatch.customerAddressPostalCodes.fetchCustomerAddressPostalCodes(null),
    fetchSalutations: () => dispatch.salutationsData.fetchSalutationsData(null),
  };
}
type Props = {
  customerInformationFilter: Pick<
    CustomerGroupFilterState,
    | "ageGroupType"
    | "salutation"
    | "customerAddressPostalCodes"
    | "activeChurnedType"
    | "customerDuration"
    | "complaintType"
  >;
  enabled: boolean;
  changeCustomerGroupFilter: (
    payload: Partial<CustomerGroupFilterState>
  ) => void;
  handleEnabledChange: (filterGroup: FilterGroup, enabled: boolean) => void;
} & ReturnType<typeof mapStateToProps> &
  ReturnType<typeof mapDispatchToProps>;

class CustomerInformationFilter extends React.Component<Props> {
  public async componentDidMount() {
    this.props.fetchSalutations();
    this.props.fetchCustomerAddressPotalCodes();
  }

  public render(): JSX.Element {
    return (
      <FilterContainer
        enabled={this.props.enabled}
        title="Kundeninformationen"
        onEnabledChange={(enabled) => {
          this.props.handleEnabledChange(
            FilterGroup.customerInformation,
            enabled
          );
        }}
      >
        {(disabled?: boolean) => (
          <Grid container={true} spacing={2}>
            <Grid item={true} xs={12}>
              <FormLabel component="div">Altersgruppe</FormLabel>
              <Select
                disabled={disabled}
                name="ageGroupType"
                value={this.props.customerInformationFilter.ageGroupType}
                onChange={this.handleAgeGroupTypeChange}
              >
                {_.values(AgeGroupType).map((item) => (
                  <MenuItem key={item} value={item}>
                    {AgeGroupLabel[item]}
                  </MenuItem>
                ))}
              </Select>
            </Grid>
            <Grid item={true} xs={12}>
              <FormLabel component="div">Kunde seit (Jahren)</FormLabel>
              <Slider
                disabled={disabled}
                formatLabel={(value, type) => {
                  return value === 10 ? `${value}+` : `${value}`;
                }}
                minValue={0}
                maxValue={10}
                onChange={this.handleCustomerDurationChange}
                value={{
                  max: this.props.customerInformationFilter.customerDuration[1],
                  min: this.props.customerInformationFilter.customerDuration[0],
                }}
              />
            </Grid>
            <Grid item={true} xs={12}>
              <FormLabel component="div">Anrede</FormLabel>
              <Select
                disabled={disabled}
                name="salutation"
                value={this.props.customerInformationFilter.salutation}
                onChange={this.handleSalutationsChange}
              >
                <MenuItem selected={true} value={"Alle"}>
                  Alle
                </MenuItem>
                {this.props.salutationsData.map((item) => (
                  <MenuItem key={item.salutation} value={item.salutation}>
                    {item.salutation}
                  </MenuItem>
                ))}
              </Select>
            </Grid>
            <Grid item={true} xs={12}>
              <ActiveChurnedFilter
                disabled={disabled}
                onChange={this.handleActiveChurnedTypeChange}
                activeChurnedType={
                  this.props.customerInformationFilter.activeChurnedType
                }
              />
            </Grid>
            <Grid item={true} xs={12}>
              <FormLabel component="div">Beschwerden</FormLabel>
              <Select
                disabled={disabled}
                name="complaintType"
                value={this.props.customerInformationFilter.complaintType}
                onChange={this.handleChangeComplaintType}
              >
                {_.values(ComplaintType).map((item) => (
                  <MenuItem key={item} value={item}>
                    {ComplaintTypeLabel[item]}
                  </MenuItem>
                ))}
              </Select>
            </Grid>

            <Grid item={true} xs={12}>
              <Autocomplete
                disabled={disabled}
                isLoading={this.props.customerAddressPostalCodes.loading}
                options={this.props.customerAddressPostalCodes.data.map(
                  (code) => ({
                    label: code,
                    value: code,
                  })
                )}
                onChange={this.handlePostalCodesChange()}
                value={
                  this.props.customerInformationFilter
                    .customerAddressPostalCodes
                }
                label="Postleitzahl"
                placeholder="Bitte auswählen..."
              />
            </Grid>
          </Grid>
        )}
      </FilterContainer>
    );
  }
  private handleAgeGroupTypeChange = (
    event: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => {
    const { name, value } = event.target;
    this.props.changeCustomerGroupFilter({ [name]: value });
  };

  private handlePostalCodesChange = () => (value: any) => {
    this.props.changeCustomerGroupFilter({
      customerAddressPostalCodes: value,
    });
  };

  private handleSalutationsChange = (
    event: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => {
    const { name, value } = event.target;
    this.props.changeCustomerGroupFilter({ [name]: value });
  };

  private handleCustomerDurationChange = (range: Range) => {
    this.props.changeCustomerGroupFilter({
      customerDuration: [range.min, range.max],
    });
  };

  private handleActiveChurnedTypeChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    this.props.changeCustomerGroupFilter({
      activeChurnedType: !this.props.customerInformationFilter
        .activeChurnedType,
    });
  };

  private handleChangeComplaintType = (
    event: React.ChangeEvent<HTMLSelectElement>
  ) => {
    const { name, value } = event.target;
    this.props.changeCustomerGroupFilter({ [name]: value });
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CustomerInformationFilter);



// WEBPACK FOOTER //
// ./src/components/Filters/CustomerInformationFilter.tsx